var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCmgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3275 779",
    role: "img",
    "aria-label": "CMG logo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3274 0 L3275 234 L2574 234 L2574 545 L3041 545 L3041 389 L3275 389 L3275 646 L3267 678 L3256 701 L3240 724 L3220 744 L3190 764 L3168 773 L3142 779 L2339 779 L2339 0 Z     M2184 779 L1948 779 L1948 643 L1870 566 L1870 563 L1948 486 L1948 333 L1804 477 L1801 477 L1638 313 L1473 477 L1470 477 L1326 333 L1326 487 L1404 563 L1326 642 L1326 779 L1090 779 L1090 0 L1327 0 L1636 310 L1947 0 L2184 0 Z     M234 545 L936 545 L936 779 L133 779 L107 773 L85 764 L60 748 L42 732 L25 711 L11 685 L0 646 L0 0 L936 0 L936 234 L234 234 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#10ff00",
    d: "M1577 583 L1558 565 L1558 563 L1560 563 L1636 486 L1638 486 L1715 563 L1715 566 L1638 643 L1636 643 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmgLogo);
export default __webpack_public_path__ + "static/media/cmg-logo.f6730debfd1c5129a674e6cd150d34e3.svg";
export { ForwardRef as ReactComponent };